<template>
  <v-container>
    <v-layout justify-center>
      <header slot="form-header" class="header">
        <h2 class="title">Entre com sua conta de Administrador</h2>
      </header>
    </v-layout>

    <v-layout justify-center>
      <v-card class="elevation-0">
        <v-card-text>
          <v-form>
            <v-text-field
                v-model="cpfcnpj"
                @keypress.enter="login(cpfcnpj, password)"
                mask="###.###.###-##"
                label="CPF"
                type="text"
            />

            <v-text-field
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :append-icon-cb="() => (showPassword = !showPassword)"
                :type="showPassword ? 'password' : 'text'"
                @keypress.enter="login(cpfcnpj, password)"
                label="Senha"
                hint="Mínimo de 8 caracteres"
                min="8"
            />
          </v-form>
        </v-card-text>

        <v-card-actions class="action">
          <v-layout justify-center>
            <v-btn large
                   color="primary"
                   @click="login()"
                   :loading="loading"
            >Entrar
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-layout>

  </v-container>
</template>

<script>
  import axios from 'axios';
  import AuthenticationService from '@/services/AuthenticationService';

  export default {
    name: 'Login',
    components: {},
    data() {
      return {
        cpfcnpj: '',
        password: '',
        showPassword: true,
        loading: false,
      };
    },
    methods: {
      login() {
        this.loading = true;

        AuthenticationService
          .login(this.cpfcnpj, this.password, 'Admin')
          .then(({ data }) => {
            axios.defaults.headers.common.Authorization = `Bearer ${ data.access_token }`;

            localStorage.setItem('access_token', data.access_token);
            localStorage.setItem('user', JSON.stringify(data.user));

            this.$store.dispatch('setCurrentUser', data.user);
            this.$router.push('/admin/dashboard');
          })
          .catch(({ response }) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style scoped lang="scss">

  .container{
    width: 500px;
    margin-top: 100px;
  }

  .v-card{
    width: 400px;
    padding: 20px;
  }

</style>
